import Axios from 'axios';

import {
	REQUEST_STATS_LOADING,
	REQUEST_STATS_HOURLY_GET,
	REQUEST_STATS_HOURLY_ERROR,
	REQUEST_STATS_DAILY_GET,
	REQUEST_STATS_DAILY_ERROR,
	REQUEST_STATS_CURRENT_GET,
	REQUEST_STATS_CURRENT_ERROR,
	REQUEST_STATS_PERFORMANCE_GET,
	REQUEST_STATS_PERFORMANCE_ERROR,
	REQUEST_STATS_PEAK_GET,
	REQUEST_STATS_PEAK_ERROR,
	REQUEST_STATS_ANOMALIES_GET,
	REQUEST_STATS_ANOMALIES_ERROR,
	REQUEST_STATS_SUMMARY_GET,
	REQUEST_STATS_SUMMARY_ERROR,
	REQUEST_STATS_ROUTE_GET,
	REQUEST_STATS_ROUTE_ERROR,
	REQUEST_STATS_THROUGHPUT_GET,
	REQUEST_STATS_THROUGHPUT_ERROR,
	REQUEST_STATS_PERCENTILES_GET,
	REQUEST_STATS_PERCENTILES_ERROR,
	REQUEST_STATS_BATCHES_GET,
	REQUEST_STATS_BATCHES_ERROR,
	REQUEST_STATS_HEALTH_GET,
	REQUEST_STATS_HEALTH_ERROR
} from './types';

// Utils
import create_query_params from '../utils/create_query_params';

const buildStatsUrl = (path, serviceName, instanceId, extraParams = {}) => {
	const params = new URLSearchParams();
	if (serviceName) params.append('service', serviceName);
	if (instanceId) params.append('instance', instanceId);
	Object.entries(extraParams).forEach(([k, v]) => { if (v != null) params.append(k, v); });
	return `${process.env.REACT_APP_SERVER_URL}/api/controller/requests/stats/${path}?${params}`;
}

export const get_request_stats_hourly = (serviceName, instanceId, hours = 24) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = buildStatsUrl('hourly', serviceName, instanceId, { hours });

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_HOURLY_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_HOURLY_ERROR, payload: { type: 'request_stats_hourly', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_daily = (serviceName, instanceId, days = 7) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = buildStatsUrl('daily', serviceName, instanceId, { days });

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_DAILY_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_DAILY_ERROR, payload: { type: 'request_stats_daily', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_current = (serviceName, instanceId, minutes = 5) => dispatch => {
	let url = buildStatsUrl('current', serviceName, instanceId, { minutes });

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_CURRENT_GET, payload: res.data });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_CURRENT_ERROR, payload: { type: 'request_stats_current', msg: err.message } });
	})
}

export const get_request_stats_performance = (serviceName, instanceId) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = buildStatsUrl('performance', serviceName, instanceId);

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_PERFORMANCE_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_PERFORMANCE_ERROR, payload: { type: 'request_stats_performance', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_peak = (serviceName, instanceId, days = 7) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = buildStatsUrl('peak', serviceName, instanceId, { days });

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_PEAK_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_PEAK_ERROR, payload: { type: 'request_stats_peak', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_anomalies = (serviceName, instanceId) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = buildStatsUrl('anomalies', serviceName, instanceId);

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_ANOMALIES_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_ANOMALIES_ERROR, payload: { type: 'request_stats_anomalies', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_summary = (serviceName, instanceId) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = buildStatsUrl('summary', serviceName, instanceId);

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_SUMMARY_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_SUMMARY_ERROR, payload: { type: 'request_stats_summary', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_route = (serviceName, instanceId, route, hours = 24) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = buildStatsUrl('route', serviceName, instanceId, { route, hours });

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_ROUTE_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_ROUTE_ERROR, payload: { type: 'request_stats_route', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_throughput = (filters) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/requests/stats/throughput?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_THROUGHPUT_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_THROUGHPUT_ERROR, payload: { type: 'request_stats_throughput', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_percentiles = (filters) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/requests/stats/percentiles?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_PERCENTILES_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_PERCENTILES_ERROR, payload: { type: 'request_stats_percentiles', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_batches = (filters) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/requests/stats/batches?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_BATCHES_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_BATCHES_ERROR, payload: { type: 'request_stats_batches', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}

export const get_request_stats_health = (filters) => dispatch => {
	dispatch({ type: REQUEST_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + '/api/controller/requests/stats/health?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: REQUEST_STATS_HEALTH_GET, payload: res.data });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: REQUEST_STATS_HEALTH_ERROR, payload: { type: 'request_stats_health', msg: err.message } });
		dispatch({ type: REQUEST_STATS_LOADING, payload: false });
	})
}
